import { actionWithDatapoint } from 'owa-analytics-actions';

import getEntryPoint from '../selectors/getEntryPoint';
import getFirstTimeUser from '../selectors/getFirstTimeUser';
import { getUserMailboxGuid } from '../utils/getMailboxGuid';

/**
 * Action to enable/disable a booking service from the store.
 */

const updateMeetingTypePrivacyAction = actionWithDatapoint(
    'updateMeetingTypePrivacyAction',
    (meetingTypeId: string, makePublic: boolean, excludeFromSelfService: boolean) => ({
        meetingTypeId,
        makePublic,
        excludeFromSelfService,
    }),
    actionMessage => ({
        customData: {
            meetingTypeId: actionMessage.meetingTypeId,
            entryPoint: getEntryPoint(),
            isNewUser: getFirstTimeUser(),
            makePublic: actionMessage.makePublic,
            excludeFromSelfService: actionMessage.excludeFromSelfService,
            mailboxGuid: getUserMailboxGuid(),
        },
    })
);

export default updateMeetingTypePrivacyAction;
